import { styled } from '@mui/material';

import { SummaryCardNew } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export const StyledSummaryCardNewContainer = styled(SummaryCardNew.Container)(
  () => ({
    border: `1px solid ${NEW_COLORS.GRAYSCALE[200]}`,
  }),
);
